import React from "react";
import EngineeringIcon from "./EngineeringIcons";

interface AnimatedDividerProps {
  variant?: "gears" | "tools" | "mixed";
  className?: string;
}

const AnimatedDivider: React.FC<AnimatedDividerProps> = ({ 
  variant = "gears", 
  className = "" 
}) => {
  const variants = {
    gears: (
      <div className="flex items-center justify-center space-x-8">
        <div className="animate-spin-slow">
          <EngineeringIcon type="gear" size="md" className="text-orange-500/60" />
        </div>
        <div className="h-px bg-gradient-to-r from-transparent via-orange-500/30 to-transparent flex-1"></div>
        <div className="animate-spin-slow-reverse">
          <EngineeringIcon type="cog" size="md" className="text-orange-400/60" />
        </div>
        <div className="h-px bg-gradient-to-r from-transparent via-orange-500/30 to-transparent flex-1"></div>
        <div className="animate-spin-slow">
          <EngineeringIcon type="pulley" size="md" className="text-orange-300/60" />
        </div>
      </div>
    ),
    tools: (
      <div className="flex items-center justify-center space-x-8">
        <div className="animate-tool-swing">
          <EngineeringIcon type="wrench" size="md" className="text-orange-500/60" animated={false} />
        </div>
        <div className="h-px bg-gradient-to-r from-transparent via-orange-500/30 to-transparent flex-1"></div>
        <div className="animate-bounce-slow">
          <EngineeringIcon type="hammer" size="md" className="text-orange-400/60" animated={false} />
        </div>
        <div className="h-px bg-gradient-to-r from-transparent via-orange-500/30 to-transparent flex-1"></div>
        <div className="animate-pulse">
          <EngineeringIcon type="bolt" size="md" className="text-orange-300/60" animated={false} />
        </div>
      </div>
    ),
    mixed: (
      <div className="flex items-center justify-center space-x-6">
        <div className="animate-spin-slow">
          <EngineeringIcon type="gear" size="sm" className="text-orange-500/60" />
        </div>
        <div className="animate-tool-swing">
          <EngineeringIcon type="wrench" size="sm" className="text-orange-400/60" animated={false} />
        </div>
        <div className="h-px bg-gradient-to-r from-transparent via-orange-500/40 to-transparent flex-1"></div>
        <div className="animate-pulley-bounce">
          <EngineeringIcon type="pulley" size="sm" className="text-orange-300/60" />
        </div>
        <div className="animate-bounce-slow">
          <EngineeringIcon type="hammer" size="sm" className="text-orange-500/60" animated={false} />
        </div>
        <div className="h-px bg-gradient-to-r from-transparent via-orange-500/40 to-transparent flex-1"></div>
        <div className="animate-spin-slow-reverse">
          <EngineeringIcon type="cog" size="sm" className="text-orange-400/60" />
        </div>
        <div className="animate-pulse">
          <EngineeringIcon type="bolt" size="sm" className="text-orange-300/60" animated={false} />
        </div>
      </div>
    )
  };

  return (
    <div className={`py-8 ${className}`}>
      {variants[variant]}
    </div>
  );
};

export default AnimatedDivider; 